module.exports = __webpack_public_path__ + "static/media/Kyle_B.bbb349ce.jpg";